import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [systemStatus, setSystemStatus] = useState('online');

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo-container">
          <div className="logo-placeholder">LEONIK</div>
        </div>
        <h1 className="header-title">Cristal Vision - Predictive Maintenance Demo</h1>
      </div>

      <div className="header-right">
        <div className="system-time">
          {currentTime.toLocaleTimeString('de-DE')}
        </div>
        <div className={`system-status ${systemStatus}`}>
          <span className="status-dot"></span>
          <span className="status-text">System {systemStatus === 'online' ? 'Online' : 'Offline'}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
